import type { Dispatch, SetStateAction } from "react"

import { useBoolean, useEffectOnce } from "react-use"

import { type TEmptyCallback, emptyCallback } from "@/shared/types/functions"

import { participantHeaderUiConfig as uiConfig } from "../ui"

function useModulesExcerptsList(): ReturnType<() => { isScrollable: boolean }> {
    const [isScrollable, setIsScrollable]: [boolean, Dispatch<SetStateAction<boolean>>] = useBoolean(false)

    useEffectOnce((): TEmptyCallback => {
        const node: HTMLDivElement = uiConfig.excerptsListRef.current
        if (!node) return emptyCallback

        const checkScrollable: TEmptyCallback = (): void => setIsScrollable(node.scrollWidth > node.clientWidth)

        checkScrollable()

        const observer: ResizeObserver = new ResizeObserver(checkScrollable)
        observer.observe(node)

        return (): void => observer.disconnect()
    })

    return { isScrollable }
}

export { useModulesExcerptsList }
